import { IShopData } from "../Abstraction/IShopData";
// images
import main1 from '../Assets/dataImages/shop/main-1.png';


export const shop:IShopData[] = [
    {
        id: 1,
        image: main1,
        title: 'Large play button logo T-shirt /// Green',
        sizes: [
            "S",
            "L",
            "XL"
        ],
        details: `Sunt sit irure ut nostrud laborum velit consectetur qui ipsum labore aliquip mollit exercitation. Minim tempor veniam incididunt cupidatat esse do est reprehenderit. Minim sit velit qui labore commodo. Aliqua pariatur culpa quis in veniam elit elit id. Aliqua ea dolore commodo occaecat esse magna ut Lorem deserunt ex occaecat magna et cupidatat. Labore mollit id excepteur
         sit cillum dolore laboris excepteur.
        Elit non est adipisicing aliquip labore laborum nostrud sit et magna excepteur occaecat cillum irure. Est id minim et amet elit commodo`,
    }
]